<template>
  <div id="app" class="min-w">
    <PageHeader :getArray="getArray"></PageHeader>
    <PageRoute :getArray="getArray"></PageRoute>
    <router-view :class="{'con-height':!isSafari,'con-height-safari':isSafari}" :key="$route.path + $route.query.t"/>
    <PageFooter></PageFooter>
  </div>
</template>

<script>
  import PageHeader from "./components/PageHeader";
  import PageRoute from "./components/PageRoute";
  import PageFooter from "./components/PageFooter";
  import i18n from "./lang"
  export default {
    name: 'App',
    components:{
      PageHeader,PageFooter,PageRoute
    },
    data(){
      return{
        isSafari:false
      }
    },
    mounted() {
      const w = window.screen.width;
      let n = parseInt((1920-w)/96)
      if(n>8){//最多缩小40%
        n=8;
      }
      document.body.style.zoom = 1-n*0.05;
      document.body.style.setProperty("--zoom", 1-n*0.05);
      window.sessionStorage.setItem('zoom',1-n*0.05)
      if(navigator.userAgent.indexOf('Safari')){
        this.isSafari = /Safari/.test(navigator.userAgent) && !/Chrome/.test(navigator.userAgent);
      }
    },
    methods:{
      getArray(){
        const menuArray = [{
          name:i18n.tc('index'),
          url:'/',
          isIndex:true,
        },{
          name:i18n.tc('groupInfo.title'),
          list:[{
            name:i18n.tc('groupInfo.recommend.name'),
            explain:i18n.tc('groupInfo.recommend.desc'),
            url:'/recommend'
          },{
            name:i18n.tc('groupInfo.history.name'),
            explain:i18n.tc('groupInfo.history.desc'),
            url:'/history'
          },{
            name:i18n.tc('groupInfo.culture.name'),
            explain:i18n.tc('groupInfo.culture.desc'),
            url:'/culture'
          },{
            name:i18n.tc('groupInfo.honor.name'),
            explain:i18n.tc('groupInfo.honor.desc'),
            url:'/honor'
          }]
        },{
          name:i18n.tc('spread.title'),
          list:[{
            name:i18n.tc('spread.goods.name'),
            explain:i18n.tc('spread.goods.desc'),
            url:'/goods'
          },{
            name:i18n.tc('spread.advert.name'),
            explain:i18n.tc('spread.advert.desc'),
            url:'/advert'
          },{
            name:i18n.tc('spread.game.name'),
            explain:i18n.tc('spread.game.desc'),
            url:'/game'
          },{
            name:i18n.tc('spread.lottery.name'),
            explain:i18n.tc('spread.lottery.desc'),
            url:'/lottery'
          }]
        },{
          name:i18n.tc('marketing.title'),
          list:[{
            name:i18n.tc('marketing.platform_0.name'),
            explain:i18n.tc('marketing.platform_0.desc'),
            url:'/platform_0'
          },{
            name:i18n.tc('marketing.platform_1.name'),
            explain:i18n.tc('marketing.platform_1.desc'),
            url:'/platform_1'
          },{
            name:i18n.tc('marketing.platform_2.name'),
            explain:i18n.tc('marketing.platform_2.desc'),
            url:'/platform_2'
          }]
        },{
          name:i18n.tc('investor.title'),
          list:[{
            name:i18n.tc('investor.notice.name'),
            explain:i18n.tc('investor.notice.desc'),
            url:'/notice',
            hasEn:true
          },{
            name:i18n.tc('investor.file.name'),
            explain:i18n.tc('investor.file.desc'),
            url:'/file',
            hasEn:true
          },{
            name:i18n.tc('investor.report.name'),
            explain:i18n.tc('investor.report.desc'),
            url:'/report',
            hasEn:true
          },{
            name:i18n.tc('investor.news.name'),
            explain:i18n.tc('investor.news.desc'),
            url:'/news',
            hasEn:true
          },{
            name:i18n.tc('investor.telephone.name'),
            explain:i18n.tc('investor.telephone.desc'),
            url:'/telephone',
            hasEn:true
          }]
        },{
          name:i18n.tc('aboutUs.title'),
          list:[{
            name:i18n.tc('aboutUs.contact.name'),
            explain:i18n.tc('aboutUs.contact.desc'),
            url:'/contact'
          },{
            name:i18n.tc('aboutUs.join.name'),
            explain:i18n.tc('aboutUs.contact.desc'),
            url:'/join'
          }]
        }]
        return menuArray;
      },
    }
  }
</script>

<style>
                      /*html {
                        filter: progid:DXImageTransform.Microsoft.BasicImage(grayscale=1);
                        -webkit-filter: grayscale(100%);}*/
</style>



// WEBPACK FOOTER //
// src/App.vue